<div class="circle-logo"><i class="icon-logo al al-logo"></i></div>